module.exports = __webpack_public_path__ + "media/failure.4a552551.wav";